// extracted by mini-css-extract-plugin
export default {"nologin":"Turn_nologin__FE1jD","blank":"Turn_blank__en1Y5","blank_img":"Turn_blank_img__A3zbe","text":"Turn_text__RO5pf","wp_turn":"Turn_wp_turn__oqiy0"};